import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../helpers/export'
import LibraryService from '../../../core/service'

//get total companies and portfolios
export const getHeaderSavedPortfolio = createAsyncThunk(
  'library/savedPortfolios/getHeaderSavedPortfolio',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LibraryService.getHeaderSavedPortfolio(params)

      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

//get type Alert getAlertProfile
export const getAlertProfile = createAsyncThunk(
  'library/alert/getAlertProfile',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LibraryService.getAlertProfile(params)

      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

//Update type alert profile
export const putUpdateAlertProfile = createAsyncThunk(
  'library/alert/putUpdateAlertProfile',
  (params) => LibraryService.putUpdateAlertProfile(params),
)

//Create new portfolio
export const postCreatePortfolio = createAsyncThunk(
  'library/savedPortfolios/postCreatePortfolio',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LibraryService.postCreatePortfolio(params)

      return res.success
        ? res.data
        : rejectWithValue({
            loading: false,
            message: res.data.errors[0],
          })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }

      return rejectWithValue({
        loading: false,
        message: error.response.data.errors[0],
      })
    }
  },
)

//update change name Portfolio
export const putUpdateNamePortfolio = createAsyncThunk(
  'library/savedPortfolios/putUpdateNamePortfolio',
  async (params, { rejectWithValue }) => {
    try {
      await LibraryService.putUpdateNamePortfolio(params)
    } catch (error) {
      const errorMessages = error.response.data?.errors
      return rejectWithValue(errorMessages ? errorMessages[0] : null)
    }
  },
)

//get data table when search portfolio
export const getSearchPortfolio = createAsyncThunk(
  'library/savedPortfolios/getSearchPortfolio',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LibraryService.getSearchPortfolio(params)

      return res.success ? res : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

//getSearchPortfolioAll
export const getSearchPortfolioAll = createAsyncThunk(
  'library/savedPortfolios/getSearchPortfolioAll',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LibraryService.getSearchPortfolioAll(params)
      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

//getIdPortfolioAllByOrg
export const getIdPortfolioAllByOrg = createAsyncThunk(
  'library/savedPortfolios/getIdPortfolioAllByOrg',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LibraryService.getIdPortfolioAllByOrg(params)
      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

//delete portfolios delDeletePortfolio
export const delDeletePortfolio = createAsyncThunk(
  'library/savedPortfolios/delDeletePortfolio',
  async (params, { dispatch }) => {
    const res = await LibraryService.delDeletePortfolio(params)

    if (res.success) {
      dispatch(getHeaderSavedPortfolio())
    }
  },
)

//search company
export const getSearchCompany = createAsyncThunk(
  'library/savedPortfolios/getSearchCompany',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LibraryService.getSearchCompany(params)

      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

// get Saved Portfolio By Org
export const getSavedPortfolioByOrg = createAsyncThunk(
  'library/savedPortfolios/getSavedPortfolioByOrg',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LibraryService.getSavedPortfolioByOrg(params)

      return res.success ? res : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

//download SavedPortfolio
export const downloadSavedPortfolio = createAsyncThunk(
  'library/savedPortfolios/downloadSavedPortfolio',
  async (params) => {
    try {
      const response = await LibraryService.downloadSavedPortfolio(params)
      handleExport(response.data, response.filename)
    } catch (error) {
      console.log(error)
    }
  },
)

//Duplicate Portfolio
export const postDuplicatePortfolio = createAsyncThunk(
  'library/savedPortfolios/postDuplicatePortfolio',
  (params) => LibraryService.postDuplicatePortfolio(params),
)
